import React, { useState } from "react";
import Cx from "classnames";

import Modal from "../Modal";
import styles from "./Duplicate.module.scss";

export default function Duplicate({ uid }) {
  const [count, setCount] = useState(1);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [slide, setSlide] = useState("intro");
  const closeModal = () => {
    setOpen(false);
    setCount(1);
    setSlide("intro");
  };
  const handleChange = (e) => {
    let val = e.target?.value;
    console.log('val.replaceAll(/[^d]/g, "")', val.replaceAll(/[^\d]/g, ""));

    setCount(val.replaceAll(/[^\d]/g, ""));

    setTimeout(() => {
      const el = document.querySelector(`.${styles.input}`);
      el.focus();
    }, 50);
  };

  const modalContent = {
    intro: () => (
      <>
        <div className={styles.policy}>
          <p>
            How many times would you like to duplicate this work?
            <br />
            <br />
            Note: The primary image will be the only file copied to the
            duplicate records.
          </p>
          <p className={styles.label}>
            <input
              className={styles.input}
              type="text"
              value={count}
              onChange={handleChange}
            />
          </p>
        </div>
        <p>
          <button className={styles.button} onClick={confirm}>
            OK
          </button>
          <button className={styles.button} onClick={closeModal}>
            Cancel
          </button>
        </p>
      </>
    ),
    confirm: () => (
      <div className={Cx({ [styles.loading]: loading })}>
        <div className={styles.policy}>
          <p>{`Duplicate this work ${count} time${count === 1 ? "" : "s"}?`}</p>
        </div>
        <p>
          <button className={styles.button} onClick={commit}>
            OK
          </button>
          <button className={styles.button} onClick={() => setSlide("intro")}>
            Cancel
          </button>
        </p>
      </div>
    ),
    success: () => (
      <div>
        <div className={styles.policy}>
          <p>
            Your new records are being created and will be listed on your
            homepage in a few moments.
          </p>
        </div>
        <p>
          <button className={styles.button} onClick={closeModal}>
            OK
          </button>
        </p>
      </div>
    ),
  };

  const ModalContent = modalContent[slide];

  const confirm = () => {
    const countInt = parseInt(count);

    if (!countInt) {
      alert("Please enter a valid number and try again.");
      setCount(1);
      return;
    }

    if (count > 50) {
      alert("You can make a maximum of 50 duplicates per request.");
      setCount(50);
      return;
    }

    setSlide("confirm");
  };

  const commit = () => {
    if (loading) return;

    setLoading(true);

    $.ajax(`/works/${uid}/duplicate`, {
      method: "POST",
      data: { count },
      success: (response) => {
        setLoading(false);
        setSlide("success");
        // alert("Your new records are being created and will be listed on your homepage in a few moments.");
      },
      error: (response, x, y) => {
        alert(
          "An error has occurred. Please try again or contact support if the issue persists."
        );
        location.reload();
      },
    });
  };

  return (
    <>
      <div className={styles.actionButton} onClick={() => setOpen(true)}>
        Duplicate
      </div>
      <Modal isOpen={open} onClose={closeModal}>
        <div className={styles.wrap}>
          <ModalContent />
        </div>
      </Modal>
    </>
  );
}
